import { render, staticRenderFns } from "./QuoteRequestCallToAction.vue?vue&type=template&id=70d730c8&scoped=true"
import script from "./QuoteRequestCallToAction.vue?vue&type=script&lang=js"
export * from "./QuoteRequestCallToAction.vue?vue&type=script&lang=js"
import style0 from "./QuoteRequestCallToAction.vue?vue&type=style&index=0&id=70d730c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d730c8",
  null
  
)

export default component.exports